<template>
  <div class="meter-online-fault-chart">
    <div class="chart-header">
      <h3 class="chart-title">{{ $t('水表在线率/故障率') }}</h3>
    </div>
    <div class="chart-container">
      <div ref="chart" style="height: 100%; width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  name: 'MeterOnlineFaultChart',
  data() {
    return {
      chart: null,
      url: {
        queryLargeScreenMeterFactory: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenMeterFactory"
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.chart = echarts.init(this.$refs.chart)
        this.chart.showLoading({
          maskColor: 'rgba(0,0,0,0.3)',
          color: '#6ED9F2',
          text: ''
        })
        this.getData()
      })
    },
    
    getData() {
      postAction(this.url.queryLargeScreenMeterFactory, {}).then(res => {
        if (res.success) {
          this.setOption(res.result)
        } else {
          this.setOption(this.getMockData())
        }
      }).catch(() => {
        this.setOption(this.getMockData())
      })
    },
    
    getMockData() {
      return {
        xdata: ['宁波水表', '三川智慧', '新天科技', '华旭科技'],
        ydata: [
          { num: 4268, rate: 0.12 },
          { num: 3187, rate: 0.08 },
          { num: 2894, rate: 0.15 },
          { num: 2135, rate: 0.05 }
        ]
      }
    },
    
    setOption(list) {
      const xData = list.xdata || []
      const yData = []
      const yData1 = []
      
      if (list.ydata) {
        list.ydata.forEach(item => {
          yData.push(item.num)
          yData1.push(item.rate * 100)
        })
      }
      
      const option = {
        textStyle: {
          color: '#fff'
        },
        grid: {
          top: '20%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}%',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF'
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          show: true,
          itemHeight: 10,
          right: 'center',
          textStyle: {
            color: '#CEE2FF'
          }
        },
        color: ['rgb(105,211,137)', '#F45535'],
        xAxis: [{
          type: 'category',
          data: xData,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 11,
            rotate: 0
          },
          axisPointer: {
            type: 'shadow'
          }
        }],
        yAxis: [
          {
            type: 'value',
            name: this.$t('数量(个)'),
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 12,
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['rgba(0, 168, 255, 0.2)']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('故障率(%)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value}%',
              color: '#D1F3FF',
              fontSize: 12
            }
          }
        ],
        series: [
          {
            name: this.$t('数量'),
            type: 'bar',
            barWidth: 15,
            data: yData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgb(105,211,137)',
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(105,211,137,0.5)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(105,211,137,0.1)',
                  }
                ],
                global: false
              }
            }
          },
          {
            name: this.$t('故障率'),
            type: 'line',
            yAxisIndex: 1,
            data: yData1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#F45535',
              width: 2
            },
            itemStyle: {
              color: '#F45535'
            }
          }
        ]
      }
      
      this.chart.hideLoading()
      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.meter-online-fault-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.chart-header {
  margin-bottom: 15px;
  text-align: center;
}

.chart-title {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.chart-container {
  flex: 1;
  min-height: 0;
}

@media (max-width: 1200px) {
  .meter-online-fault-chart {
    padding: 10px;
  }
  
  .chart-title {
    font-size: 14px;
  }
}
</style>

<style lang="less" scoped>
.meter-online-fault-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1200px) {
  .meter-online-fault-chart {
    padding: 0;
  }
}
</style>